import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ProgrammableLogicController_ShellService } from './ProgrammableLogicController.shell.service';
import { ProgrammableLogicController_OperationService } from './ProgrammableLogicController.operation.service';
import { ProgrammableLogicController_DatasourceService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_FlowService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_FrontendFlowService } from './ProgrammableLogicController.frontend.flow.service';
import { ProgrammableLogicController_ReportService } from './ProgrammableLogicController.report.index';
import { ProgrammableLogicController_LocalizationService } from './ProgrammableLogicController.localization.service';
import { ProgrammableLogicController_PLC_Hub_ComponentContextService } from './ProgrammableLogicController.PLC_Hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ProgrammableLogicController.frontend.types'
import { $frontendTypes as $types} from './ProgrammableLogicController.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { MatSelectChange } from '@angular/material/select';
import { TabItemModel, TabGroupModel } from './models/tab';
import { ProgrammableLogicController_totegroupings_gridComponent } from './ProgrammableLogicController.totegroupings_grid.component';

@Component({
  imports: [
    SharedModule,
    forwardRef(() => ProgrammableLogicController_totegroupings_gridComponent),
  ],
  selector: 'ProgrammableLogicController-PLC_Hub',
  templateUrl: './ProgrammableLogicController.PLC_Hub.component.html'
})
export class ProgrammableLogicController_PLC_HubComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
  });
  
  toolbar = {
      manage_menu: new ToolModel(new SplitButtonModel<{ configuration_menu: ButtonModel, zone_mappings: ButtonModel, message_trace: ButtonModel, logs: ButtonModel }>(
        'manage_menu',
        new ButtonStyles(null, null),
        false,
        false,
        'Manage',
        'icon-ic_fluent_settings_20_regular',
        null,
        [
          new ButtonModel('configuration_menu', new ButtonStyles(null, null), false, false, false, 'PLC configurations', ''),
          new ButtonModel('zone_mappings', new ButtonStyles(null, null), false, false, false, 'PLC zone mappings', ''),
          new ButtonModel('message_trace', new ButtonStyles(null, null), false, false, false, 'Message tracing', ''),
          new ButtonModel('logs', new ButtonStyles(null, null), false, false, false, 'Logs', '')
        ])
    , false)
  };

  actionbar = {
  };

 filters = {
  };


  filtersets = {
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      tote_groupings: new TabItemModel(
        this.rootTabGroup, 
        'Tote groupings', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_tote_groupings', { read: ProgrammableLogicController_totegroupings_gridComponent }) $tabs_tote_groupings: ProgrammableLogicController_totegroupings_gridComponent;
    //#endregion tabs children


  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Programmable logic controller hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Hub used to navigate through programmable logic controllers`;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: ProgrammableLogicController_ShellService,
  private $datasources: ProgrammableLogicController_DatasourceService,
  private $flows: ProgrammableLogicController_FlowService,
  private $frontendFlows: ProgrammableLogicController_FrontendFlowService,
  private $reports: ProgrammableLogicController_ReportService,
  private $localization: ProgrammableLogicController_LocalizationService,
  private $operations: ProgrammableLogicController_OperationService,
  private $logger: CleanupLoggerService,
  private $context: ProgrammableLogicController_PLC_Hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.tote_groupings,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Programmable logic controller hub';
    
    const $hub = this;
    const $utils = this.$utils;



    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_tote_groupings') {
      if (!isNil(this.$tabs_tote_groupings) && !this.tabs.tote_groupings.hidden) {
        this.$tabs_tote_groupings.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_plc_configurations_clicked(event = null) {
    return this.on_plc_configurations_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_plc_configurations_clickedInternal(
    $hub: ProgrammableLogicController_PLC_HubComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_PLC_Hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'PLC_Hub.on_plc_configurations_clicked');
  $shell.ProgrammableLogicController.openconnectors_gridDialog("flyout", EModalSize.Xlarge)
  }
  message_trace_clicked(event = null) {
    return this.message_trace_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async message_trace_clickedInternal(
    $hub: ProgrammableLogicController_PLC_HubComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_PLC_Hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'PLC_Hub.message_trace_clicked');
  
  
  await $shell.Utilities.openmessages_gridDialog({application_name: 'PROGRAMMABLELOGICCONTROLLER',grid_title: 'PLC message tracing', column_names: {string_2: 'Event', string_3: 'Activity'} }, 'flyout', EModalSize.Xlarge)
  }
  on_logs_clicked(event = null) {
    return this.on_logs_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_logs_clickedInternal(
    $hub: ProgrammableLogicController_PLC_HubComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_PLC_Hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'PLC_Hub.on_logs_clicked');
  await $shell.Utilities.openlogs_gridDialog({application_name: 'PROGRAMMABLELOGICCONTROLLER', grid_title: 'PLC logs'}, 'flyout', EModalSize.Xlarge);
  }
  plc_zone_mappings_clicked(event = null) {
    return this.plc_zone_mappings_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async plc_zone_mappings_clickedInternal(
    $hub: ProgrammableLogicController_PLC_HubComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_PLC_Hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'PLC_Hub.plc_zone_mappings_clicked');
  
  
  
  
  
  
  
  
  
  $shell.ProgrammableLogicController.openconnector_mappings_gridDialog("flyout", EModalSize.Xlarge)
  }
  //#endregion private flows
}
